import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Loader from "./components/Loader"; // 👈 Import your loader
import Layout from "./Layout";
import HomePage from "./pages/HomePage";
import AllReptilesPage from "./pages/AllReptilesPage";
import WishlistPage from "./pages/WishList";
import AddProductPage from "./pages/AddProjectPage";
import ReptileDetailsPage from "./pages/ReptilesDetailsPage";
import AddCategoryPage from "./pages/AddCategoriesPage";
import AddToCartPage from "./pages/AddToCartPage";
import AboutUs from "./pages/AboutPage";
import Contact from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import SignUpPage from "./pages/SignUp";
import AccountPage from "./pages/AccountPage";
import AdminPage from "./pages/AdminPanel";
import PaymentPage from "./pages/PaymentPage";
import CheckoutPage from "./pages/CheckoutPage";
import UserOrdersPage from "./pages/UserOrderPage";
import AdminOrdersPage from "./pages/AdminOrderPage";
import RestockRequestsPage from "./pages/RestockRequestsPage";
import SelectPaymentPage from "./pages/SelectPaymentPage";
import AddressPage from "./pages/AddAddressPage";
import StorePolicyPage from "./pages/StorePolicy";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./components/ScrollToTop";
import ShippingPolicyPage from "./pages/ShippingPolicy";
import Maintenance from "./pages/Maintenance";

function App() {
  const location = useLocation(); // 👈 React Router hook
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const delay = setTimeout(() => setLoading(false), 500); // Optional: fake load time
    return () => clearTimeout(delay);
  }, [location.pathname]); // Triggers on route change
  const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === "true";

  if (maintenanceMode) {
    return <Maintenance />;
  }
  return (
    <>
      <ScrollToTop />
      <Toaster
        position="center-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#1f1f1f",
            color: "#fff",
          },
        }}
      />
      {loading && <Loader />} {/* 👈 Show loader while loading */}
      <Routes>
        <Route path="/admin/dashboard" element={<AdminPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/orders" element={<UserOrdersPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/cart" element={<AddToCartPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/payment/:method" element={<PaymentPage />} />
        <Route path="/select-payment" element={<SelectPaymentPage />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/admin/categories" element={<AddCategoryPage />} />
        <Route path="/admin/addproduct" element={<AddProductPage />} />
        <Route path="/order/pending" element={<AdminOrdersPage />} />
        <Route
          path="/admin/restock-requests"
          element={<RestockRequestsPage />}
        />
        <Route path="/reptiles" element={<AllReptilesPage />} />
        <Route path="/reptiles/:id" element={<ReptileDetailsPage />} />
        <Route path="/address" element={<AddressPage />} />
        <Route path="/store-policy" element={<StorePolicyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/shipping-policy" element={<ShippingPolicyPage />} />
        <Route path="/dashboard" element={<Layout />}>
          <Route index element={<AccountPage />} />
          <Route path="/dashboard/profile" element={<AccountPage />} />
          <Route path="/dashboard/orders" element={<UserOrdersPage />} />
          <Route path="/dashboard/wishlist" element={<WishlistPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
